// extracted by mini-css-extract-plugin
export default {"wrapper":"G0-z","play":"H0-z"};